// Foto profil karyawan: URL file, kompres sebelum upload, dan foto akun yang sedang login (header).
import { reactive } from 'vue'
import appConfig from '@/utils/pengaturan'

// Foto akun yang login; diisi saat login dan diperbarui saat karyawan mengganti fotonya di ESS
export const fotoSaya = reactive({ path: localStorage.getItem('foto') || '' })

export function setFotoSaya(path) {
  fotoSaya.path = path || ''
  try {
    localStorage.setItem('foto', fotoSaya.path)
  } catch {
    // penyimpanan browser penuh/diblokir: foto tetap tampil selama halaman terbuka
  }
}

// Path relatif dari API (uploads/foto_karyawan/...) -> URL lengkap di server API
export function fotoUrl(path) {
  if (!path) return ''
  const api = localStorage.getItem('url') || appConfig.apiUrl
  return api.replace(/index\.php\/?$/, '') + path
}

// Potong tengah jadi persegi & perkecil ke 600 px sebelum dikirim (foto HP bisa > 5 MB)
export function kompresFoto(file, sisi = 600) {
  return new Promise((resolve, reject) => {
    if (!file || !/^image\/(jpeg|png|webp)$/.test(file.type)) {
      reject(new Error('Pilih file gambar JPG, PNG, atau WEBP.'))
      return
    }
    const img = new Image()
    const url = URL.createObjectURL(file)
    img.onload = () => {
      const s = Math.min(img.naturalWidth, img.naturalHeight)
      const canvas = document.createElement('canvas')
      canvas.width = canvas.height = Math.min(sisi, s)
      const ctx = canvas.getContext('2d')
      ctx.fillStyle = '#fff'
      ctx.fillRect(0, 0, canvas.width, canvas.height)
      ctx.drawImage(img, (img.naturalWidth - s) / 2, (img.naturalHeight - s) / 2, s, s, 0, 0, canvas.width, canvas.height)
      URL.revokeObjectURL(url)
      resolve(canvas.toDataURL('image/jpeg', 0.88))
    }
    img.onerror = () => {
      URL.revokeObjectURL(url)
      reject(new Error('File gambar tidak bisa dibaca.'))
    }
    img.src = url
  })
}

// Inisial untuk avatar tanpa foto: "Ahmad Sobirin" -> "AS"
export function inisial(nama) {
  return String(nama || '?')
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((k) => k[0])
    .join('')
    .toUpperCase()
}
